export const AppUpdatesAria = {
  updateAvailableBadge: () => $localize`Update verfügbar`,
  updateAvailableBadgeDetailed: (version: string) =>
    $localize`Update auf Version ${version} verfügbar`,

  updateMenuItem: () => $localize`Update durchführen und Anwendung neu laden`,
  updateMenuItemDisabled: () =>
    $localize`Kein Update verfügbar. Automatische Prüfung alle 15 Minuten.`,

  checkForUpdateButton: () => $localize`Manuell nach Updates suchen`,
  installUpdateButton: () => $localize`Verfügbares Update installieren`,
  reloadButton: () => $localize`Anwendung neu laden um Update anzuwenden`,

  updateCheckingStatus: () => $localize`Suche nach Updates läuft`,
  updateDownloadingStatus: () =>
    $localize`Update wird im Hintergrund heruntergeladen`,
  updateAvailableStatus: () => $localize`Neue Version verfügbar`,
  noUpdateStatus: () => $localize`Keine Updates verfügbar`,
  updateErrorStatus: () => $localize`Fehler beim Prüfen auf Updates`,

  updateReadyAnnouncement: () =>
    $localize`Neue Version verfügbar. Sie wird beim nächsten Seitenwechsel eingespielt oder sofort über Update durchführen im Benutzermenü.`,

  updateNotification: () =>
    $localize`Benachrichtigung: Neue Anwendungsversion verfügbar`,
  updateNotificationAction: () =>
    $localize`Jetzt aktualisieren um die neueste Version zu erhalten`,
} as const;
